"use client";

import Chevron from "@/app/assets/images/svg/chevron.svg";
import useStoreKeys from "@/hooks/useStoreKeys";
import * as Accordion from "@radix-ui/react-accordion";
import Link from "next/link";
import { FC } from "react";
import Facet from "./Facet/Facet";
import styles from "./ToggleFilterAccordian.module.scss";

interface Props {
	filter?: {
		field: string;
		type: string | null;
		filtered: boolean;
		values: [];
	};
	categories?: any[];
}

const ToggleFilterAccordion: FC<Props> = ({ filter, categories }) => {
	const { field, type, filtered, values } = filter || {};
	const { store, lang } = useStoreKeys();

	if (!field) return null;

	// Filter out any accordions we don't want to show here:
	if (field && ["categories_hierarchy", "category_ids"].includes(field))
		return null;

	return (
		<Accordion.Root
			type='single'
			collapsible
			className={styles.accordionRoot}
			defaultValue={field || "category"}
		>
			<Accordion.Item
				value={field || "category"}
				className={styles.AccordionItem}
			>
				<Accordion.Header className={styles.AccordionHeader}>
					<Accordion.Trigger className={styles.AccordionTrigger}>
						{field && manageFilterCategoryName(field)}
						{categories && "Category"}
						<Chevron aria-labelledby='directional chevron' />
					</Accordion.Trigger>
				</Accordion.Header>
				<Accordion.Content className={styles.AccordionContent}>
					{field &&
						values?.map(
							(item: {
								filtered: boolean;
								value?: string | undefined;
								label: string;
								count: number;
								high?: number | undefined;
								low?: number | undefined;
							}) => (
								<Facet
									key={`${field}-${item.label}`}
									field={field}
									facet={item}
								/>
							),
						)}
					{categories?.map(({ path, name }) => (
						<Link
							key={path}
							href={`/${store}/${lang}${path}`}
							className={styles.categoryLink}
							prefetch={false}
						>
							{name}
						</Link>
					))}
				</Accordion.Content>
			</Accordion.Item>
		</Accordion.Root>
	);
};

export default ToggleFilterAccordion;

const manageFilterCategoryName = (field: string) => {
	const splitString = field.split("_");

	if (splitString.length === 1)
		return splitString[0].charAt(0).toUpperCase() + splitString[0].slice(1);

	return splitString[1].charAt(0).toUpperCase() + splitString[1].slice(1);
};
